<div class="m-content padding">
    <div class="m-content padding">
        <div class="m-portlet">
            <div class="m-portlet__body">
                <div class="row">
                    <div class="col-4">
                        <h3>Advanced Certification</h3>
                    </div>
                    <div class="col-7"></div>
                    <button class="btn btn-info notranslate" (click)="goBack()">Back</button>
                </div>
                <hr>
                <div [formGroup]="advanceCerificationForm">
                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
                            Sector:
                            <span class="red">*</span>
                        </label>
                        <div class="col-5">
                            <select disabled class="form-control m-input" formControlName="sector" id="exampleSelect1"
                                placeholder="Select Sector" [compareWith]="compareSectors" required>
                                <option value="" disabled>Select Sector</option>
                                <option [ngValue]="sector" *ngFor="let sector of sectors">{{sector.name}}</option>
                            </select>
                            <app-form-control-messages [control]="advanceCerificationForm.get('sector')"
                                [name]="'Sector'"></app-form-control-messages>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
                            Job Role (QP Code):
                            <span class="red">*</span>
                        </label>
                        <div class="col-5">
                            <select disabled [compareWith]="compareJobRoleName" class="form-control m-input"
                                formControlName="jobRole" id="exampleSelect1" required>
                                <option value="" disabled>Select Job Role</option>
                                <option [ngValue]="jobRole" *ngFor="let jobRole of jobRoles">
                                    {{jobRole.jobroleName}}
                                </option>
                            </select>
                            <app-form-control-messages [control]="advanceCerificationForm.get('jobRole')"
                                [name]="'Job Role'">
                            </app-form-control-messages>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
                            Training Model:
                            <span class="red">*</span>
                        </label>
                        <div class="col-5">
                            <select disabled [compareWith]="compareTrainingModel" class="form-control m-input"
                                formControlName="trainingModel" id="exampleSelect1" placeholder="Select Training Mdoel"
                                required>
                                <option value="">Select Training Model</option>
                                <option [ngValue]="training" *ngFor="let training of trainingModels">
                                    {{training.name}}
                                </option>
                            </select>
                            <app-form-control-messages [control]="advanceCerificationForm.get('trainingModel')"
                                [name]="'Training Model'"></app-form-control-messages>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
                            Certification Type:
                            <span class="red">*</span>
                        </label>
                        <div class="col-5">
                            <select disabled [compareWith]="compareCertificationType" class="form-control m-input"
                                formControlName="typeOfCertification" id="exampleSelect1">
                                <option value="">Select Certification Type</option>
                                <option [ngValue]="type.name" *ngFor="let type of typeOfCertification">
                                    {{type.name}}
                                </option>
                            </select>
                            <app-form-control-messages [control]="advanceCerificationForm.get('typeOfCertification')"
                                [name]="'Certification Type'"></app-form-control-messages>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
                            Trainer/Assessor Academy:
                            <span class="red">*</span>
                        </label>
                        <div class="col-5">
                            <select [compareWith]="compareAcademicType" class="form-control m-input" formControlName="academy" id="exampleSelect1"
                                placeholder="Select Academy" required>
                                <option value="" disabled>Select Academy</option>
                                <option [ngValue]="academy" *ngFor="let academy of academyList">
                                    {{academy.name}}
                                </option>
                            </select>
                            <app-form-control-messages [control]="advanceCerificationForm.get('academy')"
                                [name]="'Academy Name'"></app-form-control-messages>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label class="col-3 col-form-label">
                            Country:
                            <span class="red">*</span>
                        </label>
                        <div class="col-5">
                            <div class="input-group">
                                <select [compareWith]="showCountry" class="form-control" formControlName="country">
                                    <option value="" disabled>Select Country</option>
                                    <option class="notranslate" *ngFor="let country of countries" [ngValue]="country">
                                        {{country.country}}
                                    </option>
                                </select>
                            </div>
                            <app-form-control-messages [control]="advanceCerificationForm.get('country')"
                                [name]="'Country'">
                            </app-form-control-messages>
                        </div>
                    </div>
                    <div class="form-group m-form__group row" *ngIf="showField">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
                            State:
                            <span class="red">*</span>
                        </label>
                        <div class="col-5">
                            <select [compareWith]="compareStateAndDistrict" class="form-control m-input"
                                (change)="getDistricts()" formControlName="state" id="exampleSelect1"
                                placeholder="Select Sector" required>
                                <option value="" disabled>Select State</option>
                                <option [ngValue]="state" *ngFor="let state of states">{{state.name}}</option>
                            </select>
                            <app-form-control-messages [control]="advanceCerificationForm.get('state')"
                                [name]="'State'">
                            </app-form-control-messages>
                        </div>
                    </div>
                    <div class="form-group m-form__group row" *ngIf="showField">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
                            District:
                            <span class="red">*</span>
                        </label>
                        <div class="col-5">
                            <select [compareWith]="compareStateAndDistrict" class="form-control m-input"
                                formControlName="district" id="exampleSelect1" placeholder="Select district" required>
                                <option value="" disabled>Select District</option>
                                <option [ngValue]="district" *ngFor="let district of districts">{{district.name}}
                                </option>
                            </select>
                            <app-form-control-messages [control]="advanceCerificationForm.get('district')"
                                [name]="'District'">
                            </app-form-control-messages>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
                            Certificate ID:
                        </label>
                        <div class="col-5">
                            <input class="form-control m-input nameBackground" type="text"
                                formControlName="certificateId" placeholder="Certificate Id">
                            <app-form-control-messages [control]="advanceCerificationForm.get('certificateId')"
                                [name]="'Certificate ID'"></app-form-control-messages>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
                            Certificate Issued On:
                        </label>
                        <div class="col-5">
                            <input type="text" class="form-control m-input" (focusout)="assignedDate($event)"
                                readonly="true" placeholder="Select Date" [id]="dateId1"
                                formControlName="certificateIssueDate">
                        </div>
                    </div>
                    <div class="form-group m-form__group row" *ngIf="showUpload == true && loginType !== 'SSC'">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
                            Supporting Document:
                        </label>
                        <div class="col-sm-4">
                            <app-upload-file [formValue]="advanceCerificationForm.get('advancedCertificate')"
                                [(value)]="docLink" info="only jpg, png,jpeg, pdf" fileType="disabilityProof">
                            </app-upload-file>
                            <input type="hidden" formControlName="advancedCertificate" #fileInput>
                            <app-form-control-messages [control]="advanceCerificationForm.get('advancedCertificate')"
                                [name]="'Photo'"></app-form-control-messages>
                        </div>
                    </div>
                    <!-- <div class="form-group m-form__group row" *ngIf="showDownlod == true">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
                            Download Supporting Document:
                        </label>
                        <div class="col-4">
                            <app-file-download *ngIf="docLink !== ''" [fileURL]="docLink" [buttonText]="buttonText">
                            </app-file-download>
                            <div *ngIf="docLink === ''" style="margin-top: 10px">NA</div>
                        </div>
                    </div> -->
                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label">
                            Remarks to SSC:
                        </label>
                        <div class="col-5">
                            <textarea name="" id="" class="form-control m-input" cols="100" rows="5"
                                formControlName="remarkToSsc" placeholder="Enter Remarks to SSC"></textarea>
                            <app-form-control-messages [control]="advanceCerificationForm.get('remarkToSsc')"
                                [name]="'Remarks to SSC'"></app-form-control-messages>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <div class="col-1"></div>
                        <label for="example-search-input" class="col-3 col-form-label" style="color:red">
                            Disclaimer:
                            <span class="red">*</span>
                        </label>
                        <div class="col-5">
                            <div class="row">
                                <p>{{disclaimer?disclaimer:"sorry could not get disclaimer"}}</p>
                            </div>
                            <div>
                                <label class="m-checkbox">
                                    <input type="checkbox" formControlName="declaration"> I Agree
                                    <span></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row" style="padding-bottom:30px">
                        <div style="margin-left:40%">
                            <button class="btn btn-info" (click)="submitCetificationDetails()">Submit</button>
                            <button class="btn btn-secondary" (click)="goBack()">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>